/*
 * Voorbeeldafbeelding van een YouTube-video kiezen.
 *
 * Niet elke video heeft elk formaat. Ontbreekt een formaat, dan stuurt YouTube
 * géén foutmelding, maar een grijs vervangerplaatje van 120x90 pixels met een
 * gewone "gelukt"-status. Een terugval op alleen 'error' werkt daarom niet: die
 * schiet nooit aan, en het grijze plaatje wordt uitgerekt over de hele breedte.
 *
 * Vandaar dat hier op formaat wordt gecontroleerd. Is de afbeelding kleiner dan
 * 480 pixels breed, dan is het het vervangerplaatje en wordt het volgende
 * formaat geprobeerd: maxresdefault -> sddefault -> hqdefault.
 */
(function () {
  var FORMATEN = ['maxresdefault', 'sddefault', 'hqdefault'];
  var MINIMALE_BREEDTE = 480;

  function volgendFormaat(img) {
    var stap = Number(img.dataset.ytStap || 0) + 1;
    if (stap >= FORMATEN.length) return;

    img.dataset.ytStap = stap;
    img.src = 'https://i.ytimg.com/vi/' + img.dataset.ytId + '/' + FORMATEN[stap] + '.jpg';
  }

  function controleer(img) {
    if (img.naturalWidth && img.naturalWidth < MINIMALE_BREEDTE) volgendFormaat(img);
  }

  function isPoster(node) {
    return node && node.classList && node.classList.contains('km-video__poster-yt');
  }

  // load en error bubbelen niet, dus in de capture-fase meelezen.
  document.addEventListener(
    'load',
    function (event) {
      if (isPoster(event.target)) controleer(event.target);
    },
    true
  );

  document.addEventListener(
    'error',
    function (event) {
      if (isPoster(event.target)) volgendFormaat(event.target);
    },
    true
  );

  // Afbeeldingen die al klaar zijn (bijvoorbeeld uit de cache) ook nalopen.
  function loopNa() {
    document.querySelectorAll('.km-video__poster-yt').forEach(function (img) {
      if (img.complete) controleer(img);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loopNa);
  } else {
    loopNa();
  }
})();
